import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedUiTableModule } from '@snelstart/ui-table';
import { FeatureTaxVatListComponent } from './tax-vat-list/feature-tax-vat-list.component';
import {SharedUiButtonModule} from "@snelstart/ui-button";

@NgModule({
  imports: [CommonModule, SharedUiTableModule, SharedUiButtonModule, FeatureTaxVatListComponent],
  declarations: [],
  exports: [FeatureTaxVatListComponent],
})
export class FeatureTaxVatListModule {}
